import Centerfold from './Centerfold';

export default Centerfold;
